//@ts-check --jsx
import React from 'react';
import throttle from 'underscore/modules/throttle';

const MakeSticky = ComposedComponent =>
    class Sticky extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                sticky: false,
                height: null
            };
            this.onScroll = this.onScroll.bind(this);
            this.onScrollThrottled = throttle(this.onScroll, props.wait || 0);
        }

        componentDidMount() {
            window.addEventListener('scroll', this.onScrollThrottled, false);
        }

        componentWillUnmount() {
            this.doc = null;
            window.removeEventListener('scroll', this.onScrollThrottled, false);
        }

        onScroll() {
            this.doc = document.documentElement;
            if (!this.el) {
                return;
            }
            const position = this.el.getBoundingClientRect();
            if (!this.state.height && position.height) {
                this.setState({
                    height: position.height
                });
            }
            // const top = (window.pageYOffset || this.doc.scrollTop) - (this.doc.clientTop || 0);
            if (position && position.top <= 0) {
                if (!this.state.sticky) {
                    this.setState({
                        sticky: true
                    });
                }
            } else {
                if (this.state.sticky) {
                    this.setState({
                        sticky: false
                    });
                }
            }
        }

        render() {
            let { position, zIndex } = this.props;

            //return before doing anything, we don't know how to make the element sticky.
            if (!position) {
                return null;
            }

            const positions = {
                top: 'sticky-top',
                bottom: 'sticky-bottom'
            };

            const getStickyClasses = () =>
                this.state.sticky ? `myt-sticky ${positions[position]}` : '';
            const wrapperStyles = {
                height: this.state.height ? this.state.height : 'auto'
            };
            const stickyStyles = {
                zIndex: zIndex ? zIndex : 10
            };

            return (
                <>
                    <div
                        className="myt-sticky-wrapper"
                        ref={el => (this.el = el)}
                        style={wrapperStyles}>
                        <div
                            className={getStickyClasses()}
                            style={stickyStyles}>
                            <ComposedComponent {...this.props} />
                        </div>
                    </div>
                </>
            );
        }
    };

export default MakeSticky;
